export default {
  title: 'Se pare că ești offline',
  description:
    'Te rugăm să apeși „Reîncarcă pagina" și/sau verifică conexiunea la internet pentru a te asigura că ești online 😊',
  custom_button: {
    reload: 'Reîncarcă pagina',
  },
};
